import classNames from 'classnames';
import React, { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { makeId } from '../../../utilities/idComponent';
import { FieldContainer, FontStyle } from '../FieldContainer';

type TextAreaProps = {
  name: string;
  disabled?: boolean;
  isHorizontal?: boolean;
  label?: string | React.ReactNode;
  labelStyle?: FontStyle;
  value?: string;
  placeholder?: string;
  helpText?: string;
  errorMessage?: string;
  boldLabel?: boolean;
  rows?: number;
  subLabel?: string;
  subLabelPosition?: 'vertical' | 'horizontal';
  helpTextAlign?: 'left' | 'right';
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
} & DetailedHTMLProps<
  InputHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
>;

const TextArea = ({
  boldLabel,
  errorMessage,
  helpText,
  helpTextAlign,
  id,
  label,
  name,
  placeholder,
  rows,
  subLabel,
  subLabelPosition,
  value,
  onChange,
  disabled = false,
  isHorizontal = false,
  labelStyle = FontStyle.default,
  required,
  ...props
}: TextAreaProps) => (
  <FieldContainer
    label={label}
    name={name}
    fontStyle={labelStyle}
    helpText={helpText}
    isHorizontal={isHorizontal}
    isRequired={required}
    errorMessage={errorMessage}
    subLabel={subLabel}
    subLabelPosition={subLabelPosition}
    helpTextAlign={helpTextAlign}
    boldLabel={boldLabel}
  >
    <textarea
      placeholder={placeholder}
      className={classNames('form-control font-body-MdRegular', {
        'is-invalid': errorMessage,
      })}
      disabled={disabled}
      name={name}
      value={value}
      onChange={onChange}
      rows={rows || 0}
      id={makeId('ipt', name, id)}
      {...props}
    />
  </FieldContainer>
);

export default TextArea;
